"use strict";
/*
 * Created on 10. 1. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * State of exported entity.
 * @author Radek Beran
 * @author VRu
 */

var ExportedEntityState;

(function (ExportedEntityState) {
  /** Entity newly enqueued for export. */
  ExportedEntityState["Waiting"] = "Waiting";
  /** Export is already processing in IDB. */

  ExportedEntityState["Processing"] = "Processing";
  /** Export has finished with a failure. */

  ExportedEntityState["Failed"] = "Failed";
  /** Export has finished successfully. */

  ExportedEntityState["Success"] = "Success";
  /** Entity was finally closed, moved to Released or ExportFailed state within the application. */

  ExportedEntityState["Closed"] = "Closed";
  /** Export files are being created. */

  ExportedEntityState["Running"] = "Running";
})(ExportedEntityState = exports.ExportedEntityState || (exports.ExportedEntityState = {}));
/**
 * Simplified version of {@link ExportedEntityState} which gather some states into one.
 * <br/>
 * May be used to simplify API queries.
 *
 * @author JMe
 */


var ExportedEntityAggregatedState;

(function (ExportedEntityAggregatedState) {
  /** {@link ExportedEntityState.Success} or {@link ExportedEntityState.Closed} with {@link ExportedEntity.error} equal to null. */
  ExportedEntityAggregatedState["Succeeded"] = "SUCCEEDED";
  /** {@link ExportedEntityState.Waiting}, {@link ExportedEntityState.Processing}, {@link ExportedEntityState.Running} */

  ExportedEntityAggregatedState["Pending"] = "PENDING";
  /** {@link ExportedEntityState.Failed} or {@link ExportedEntityState.Closed} with defined {@link ExportedEntity.error}. */

  ExportedEntityAggregatedState["Failed"] = "FAILED";
})(ExportedEntityAggregatedState = exports.ExportedEntityAggregatedState || (exports.ExportedEntityAggregatedState = {}));